import React from "react";

const AccountContext = React.createContext();

export default AccountContext;
